import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
import "../../../../../../../index.css";
class TrinityResultTableContent extends Component {
  render() {
    const { result } = this.props;
    return (
      <table className="trinity_result_table_content_box">
        <tbody>
          <tr>
            <td
              style={{
                textAlign: "left",
                paddingLeft: "5px",
                borderLeft: 0,
                borderTop: 0,
                borderRight: 0,
                color: "#292929",
                fontSize: "16px",
                fontWeight: "bold",
              }}
              colSpan="5"
            >
              {result.schoolName}{" "}
              <NavLink to={result.ruleUrl}>招生章程 &gt;</NavLink>
            </td>
          </tr>
          {result.trinityMajorResults.map((item, index) => {
            return (
              <tr key={index}>
                <td
                  style={{
                    borderLeft: 0,
                    width: "32%",
                    textAlign: "left",
                    paddingLeft: "5px",
                  }}
                >
                  {item.majorName}
                </td>
                <td style={{ width: "8%", borderLeft: 0 }}>{item.planNum}</td>
                <td style={{ width: "8%", borderLeft: 0 }}>
                  {item.ecMinScore === "" ? "/" : item.ecMinScore}
                </td>
                <td
                  className={index !== 0 ? "display_none" : ""}
                  style={
                    result.firstTrial === "/"
                      ? { width: "32%", borderLeft: 0 }
                      : {
                          width: "32%",
                          borderLeft: 0,
                          textAlign: "justify",
                          lineHeight: "1.5",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                        }
                  }
                  rowSpan={result.trinityMajorResults.length}
                >
                  {result.firstTrial}
                </td>
                <td
                  className={index !== 0 ? "display_none" : ""}
                  style={{ width: "20%", borderLeft: 0 }}
                  rowSpan={result.trinityMajorResults.length}
                  dangerouslySetInnerHTML={{
                    __html: result.applyTime + "<br><br>" + result.examTime,
                  }}
                ></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default TrinityResultTableContent;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityResult/components/TrinityResultTable/components/TrinityResultTableContent/index.js